var map = {
	"./Education_Flyer.jpg": 81,
	"./MainLabor.jpg": 117,
	"./MainMarriage.jpg": 205,
	"./Russell-Watkins.jpg": 118,
	"./bdphand.png": 206,
	"./bdplogo.png": 207,
	"./educationArticle1.jpg": 152,
	"./educationArticle2.jpg": 153,
	"./educationArticle3.jpg": 154,
	"./educationProject/EducationProject1.jpg": 208,
	"./education_video.mp4": 85,
	"./educationmain.jpg": 119,
	"./healthArticle1.jpg": 155,
	"./healthArticle2.jpg": 156,
	"./healthcard1.jpg": 157,
	"./home.jpg": 209,
	"./laborArticle1.jpg": 158,
	"./laborArticle2.jpg": 159,
	"./laborArticle3.jpg": 160,
	"./logoBDP.png": 114,
	"./mainProstitution.jpg": 120,
	"./marriageArticle1.jpg": 161,
	"./marriageArticle2.jpg": 162,
	"./marriageArticle3.jpg": 163,
	"./oldteam.jpg": 116,
	"./pinkMarriage.jpg": 121,
	"./prostitutionArticle1.jpg": 164,
	"./prostitutionArticle2.jpg": 165,
	"./prostitutionArticle3.jpg": 166,
	"./ramadan/1.jpg": 122,
	"./ramadan/2.jpg": 123,
	"./ramadan/3.jpg": 124,
	"./ramadan/4.jpg": 125,
	"./ramadan/5.jpg": 126,
	"./ramadan/6.jpg": 127,
	"./ramadan/7.jpg": 128,
	"./ramadan2019/Ramadan1.jpeg": 210,
	"./team/Amina.jpg": 129,
	"./team/Ashabul.jpg": 130,
	"./team/Ferdous.jpg": 131,
	"./team/Jaheen.JPG": 132,
	"./team/Karima.jpg": 133,
	"./team/Marjan.jpg": 134,
	"./team/Momo.jpg": 135,
	"./team/Mosammat.jpg": 136,
	"./team/Naiful.jpg": 137,
	"./team/Noshin.jpg": 138,
	"./team/Prema.jpg": 139,
	"./team/Priya.jpg": 140,
	"./team/Sila.jpg": 141,
	"./team/Simran.jpg": 142,
	"./team/Tahmid.jpg": 143,
	"./team/Tanjeela.jpg": 144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;